var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_2059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8845 17.3838L12.2231 16.1863L9.46206 17.9993L7.53555 17.9984L4.77281 16.1863L1.11314 17.3838L0 13.2557L1.11326 8.67426L0 4.80082L1.11326 0L6.83173 3.75286H10.1659L15.8845 0L16.9977 4.80082L15.8845 8.67426L16.9977 13.2557L15.8845 17.3838Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11426 0L6.83284 3.75549L6.6055 6.33284L1.11426 0ZM4.77405 13.2574L7.29017 15.3628L4.77405 16.1862V13.2574ZM7.08904 9.77666L6.6055 6.33468L3.51006 8.67532L3.50838 8.67439V8.6761L3.51796 11.0854L4.77321 9.77679L7.08904 9.77666ZM15.8847 0L10.1662 3.75549L10.3928 6.33284L15.8847 0ZM12.2251 13.2574L9.70884 15.3628L12.2251 16.1862V13.2574ZM13.4899 8.67597V8.67426L13.4892 8.67518L10.3936 6.33468L9.91008 9.77666H12.225L13.481 11.0851L13.4899 8.67597Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77293 16.1861L1.11326 17.3835L0 13.2573H4.77293V16.1861ZM7.08792 9.77563L7.78696 14.7517L6.81808 11.9849L3.51613 11.085L4.77209 9.77577L7.08792 9.77563ZM12.2247 16.1861L15.8845 17.3835L16.9977 13.2572H12.2247C12.2247 13.2573 12.2247 16.1861 12.2247 16.1861ZM9.9098 9.77563L9.21077 14.7517L10.1795 11.9849L13.4817 11.085L12.2249 9.77577L9.9098 9.77563Z",
    fill: "#E34807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2558L1.11326 8.67433H3.50727L3.51601 11.0844L6.81832 11.9843L7.78708 14.751L7.28905 15.3603L4.77293 13.2549H0V13.2558ZM16.9977 13.2558L15.8845 8.67433H13.4903L13.4816 11.0844L10.1795 11.9843L9.21065 14.751L9.70856 15.3603L12.2248 13.2549H16.9977V13.2558ZM10.1659 3.75293H6.83173L6.60534 6.33028L7.7872 14.7482H9.21077L10.3933 6.33028L10.1659 3.75293Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11326 0L0 4.80081L1.11326 8.67426H3.50727L6.60438 6.33297L1.11326 0ZM6.39607 10.7752H5.31154L4.72109 11.411L6.81904 11.9822L6.39607 10.7743V10.7752ZM15.8845 0L16.9977 4.80081L15.8845 8.67426H13.4903L10.3933 6.33297L15.8845 0ZM10.6032 10.7752H11.6893L12.2797 11.4118L10.1794 11.9842L10.6032 10.7743V10.7752ZM9.46122 16.3571L9.70868 15.362L9.21065 14.7528H7.786L7.28809 15.362L7.53543 16.3571",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46168 16.3569V18.0001H7.53613V16.3569H9.46168Z",
    fill: "#C0C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 16.1844L7.5369 17.9992V16.356L7.28944 15.3611L4.77344 16.1844ZM12.2245 16.1844L9.46089 17.9992V16.356L9.70835 15.3611L12.2245 16.1844Z",
    fill: "#E7EBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_2059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.a34e582d87105cad8e394b527662fcdf.svg";
export { ForwardRef as ReactComponent };